import { render, staticRenderFns } from "./CommuncationRow.vue?vue&type=template&id=0104f9e0&scoped=true&"
import script from "./CommuncationRow.vue?vue&type=script&lang=js&"
export * from "./CommuncationRow.vue?vue&type=script&lang=js&"
import style0 from "./CommuncationRow.vue?vue&type=style&index=0&id=0104f9e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0104f9e0",
  null
  
)

export default component.exports